<template>
<div class="navbar">
    <div class="navbar-fixed">
    <nav class="black">
        <div class="container">
            <div class="nav-wrapper">
                <a href="#" class="brand-logo">My Portfolio</a>
                <ul class="right hide-on-med-and-down" id="navList">
                    <li><a href="#landing">Home</a></li>
                    <li><a href="#intro">About Me</a></li>
                    <li><a href="#work">Projects</a></li>
                    <li><a href="#contact">Contact</a></li>
                </ul>
            </div>
        </div>
    </nav>
</div>
</div>
</template>

<script>
export default {
    name: 'Navbar',
    data(){
    return {

    }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Navbar.vue